
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse
} from '@angular/common/http';

import {Injectable, Injector} from '@angular/core';
import {Storage} from '@ionic/storage';
import { throwError, from } from 'rxjs';
import {Observable} from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { TokenResponse } from '../entities/token';

@Injectable({
	providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
	currentRequest: HttpRequest<any>;
  	private token: string;

	constructor(
		private storage: Storage, 
		private injector: Injector,
		private authService: AuthService){
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let clone: HttpRequest<any>;

		this.token = this.authService.getToken();

		if( this.token != null ){
			req = req.clone({headers: req.headers.set('Authorization', 'Bearer ' + this.token)});

			//let token = this.authService.getToken();
			clone = req.clone({
				setHeaders: {
					Accept: `application/json`,
					'Content-Type': `application/json`,
					Authorization: `Bearer ${this.token}`
				}
			});
		}else{
			console.log("sin token");
			clone = req.clone({
				setHeaders: {
					Accept: `application/json`,
					'Content-Type': `application/json`
				}
			});
		}

		return new Observable<HttpEvent<any>>(
			subscriber => {
				// first try for the request
				next.handle(req)
				.subscribe(
					(event: HttpEvent<any>) => {
						if (event instanceof HttpResponse) {
							// the request went well and we have valid response
							// give response to user and complete the subscription
							subscriber.next(event);
							subscriber.complete();
						}
					},
					error => {
						if (error instanceof HttpErrorResponse && (error.status === 403 || error.status === 401 || error.status === 400)) {
							// try to re-log the user with EMAIL
							console.log("este error:");
							console.log(error.error);
							if(error.error.error == "invalid_token"){
								this.authService.setToken(null)
								subscriber.error(error);
							}else if(error.error.code == 1409){
								subscriber.error(error);
							}else{
								this.authService.setToken(null)
								subscriber.error(error);
								/*
								this.authService.refreshToken().subscribe( 
									res => {
										let newToken = res.access_token;

										this.authService.setToken(res.access_token)
										this.authService.setRefreshToken(res.refresh_token)

										let newRequest = req.clone({
											setHeaders: {
												Accept: `application/json`,
												'Content-Type': `application/json`,
												Authorization: `Bearer ${newToken}`
											}
										});

										next.handle(newRequest).subscribe(
											newEvent => {
												if (newEvent instanceof HttpResponse) {
													// the second try went well and we have valid response
													// give response to user and complete the subscription
													subscriber.next(newEvent);
													subscriber.complete();
												}
											}, 
											error => {
												// second try went wrong -> throw error to subscriber
												subscriber.error(error);
											}
										);
									},
									error => {
										console.log('nok')
										subscriber.error(error);
									}
								);
								*/                
							}
						}else if(error instanceof HttpErrorResponse && (error.status === 500)) {
							subscriber.error(error);
						}else{
							subscriber.error(error);
						}
					}
				);
			}
		);
	}

	private handleError(error: any) {
		let errorMsg = error.message ? error.message :
			error.status ? `${error.status} - ${error.statusError}` : 'Server error';
		
		console.error('Error en Sage: ' + errorMsg + '. \n Fecha del error: ' + new Date());

		return throwError(error);
	}
}